<div class="modal-header text-bg-primary">
  <h4 class="modal-title" id="modal-title">INICIAR SESIÓN</h4>
</div>

<div class="modal-body px-0">
  <div class="container">
    <div class="login-container">
      <div class="login-content">
        @if (form) {
        <form [formGroup]="form" class="row py-3 py-lg-4" (ngSubmit)="submit()">
          <div class="col-12 mb-4">
            <div class="form-floating">
              <input
                id="store"
                type="text"
                class="form-control"
                placeholder="Tienda"
                formControlName="store"
                [ngClass]="{
                  'is-invalid':
                    form.get('store')?.invalid &&
                    (form.get('store')?.dirty || form.get('store')?.touched)
                }"
                required
              />

              <label for="store" class="text-warning font-italic">
                Tienda
              </label>
            </div>

            @if (form.get('store')?.invalid && (form.get('store')?.dirty ||
            form.get('store')?.touched)) {
            <div class="mt-2 ps-1">
              <span class="text-danger"> Ingrese la tienda. </span>
            </div>
            }
          </div>

          @if(password && form.get('password')) {
          <div class="col-12">
            <div class="form-floating">
              <input
                id="password"
                type="password"
                class="form-control"
                placeholder="Contraseña"
                formControlName="password"
                [ngClass]="{
                  'is-invalid':
                    form.get('password')?.invalid &&
                    (form.get('password')?.dirty ||
                      form.get('password')?.touched)
                }"
                required
              />

              <label for="password" class="text-warning font-italic">
                Contraseña
              </label>
            </div>

            @if (form.get('password')?.invalid && (form.get('password')?.dirty
            || form.get('password')?.touched)) {
            <div class="mt-2 ps-1">
              <span class="text-danger"> Ingrese su correo electrónico. </span>
            </div>
            }
          </div>
          }
          <!--  -->
          @if (apiAlert) {
          <div class="col-12 mt-4">
            <ngb-alert [type]="apiAlert.type" (closed)="close()">
              {{ apiAlert.message }}
            </ngb-alert>
          </div>
          }
        </form>
        }
      </div>
    </div>
  </div>
</div>

<div class="modal-footer">
  <div class="row">
    <div class="col-6 mx-auto">
      <button
        type="button"
        class="btn btn-warning w-100"
        (click)="submit()"
        [ngClass]="{ placeholder: loading }"
        [disabled]="loading || (form.invalid && (form.touched || form.dirty))"
      >
        Entrar
      </button>
    </div>
  </div>
</div>
